module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center",
    attrs: {
      "id": "ded"
    }
  }, [_vm._v("To the memory of"), _c('br'), _vm._v("Judy-Lynn Del Rey,"), _c('br'), _vm._v("editor extraordinary,"), _c('br'), _vm._v("who bought this book for one dollar"), _c('br'), _vm._v("—but never knew if she got her money’s worth")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-917a9800","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780795324857_epub_ded_r1.vue
// module id = 63
// module chunks = 0